<template>
  <Teleport to="body">
    <div class="app-toast-wrap" aria-live="polite">
      <TransitionGroup name="app-toast" tag="div" class="app-toast-list">
        <div
          v-for="t in toasts"
          :key="t.id"
          class="app-toast-item"
          :class="`app-toast--${t.severity}`"
          @click="dismiss(t.id)"
        >
          <span class="app-toast-icon">
            <i v-if="t.severity === 'success'" class="pi pi-check-circle" />
            <i v-else-if="t.severity === 'error'" class="pi pi-times-circle" />
            <i v-else-if="t.severity === 'warn'" class="pi pi-exclamation-triangle" />
            <i v-else class="pi pi-info-circle" />
          </span>
          <span class="app-toast-body">
            <span class="app-toast-summary">{{ t.summary }}</span>
            <span class="app-toast-detail">{{ t.detail }}</span>
          </span>
          <button class="app-toast-close" type="button" aria-label="Cerrar">×</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script>
import { registerToast } from "@/services/toastBus.js";

export default {
  name: "AppToast",
  data() {
    return { toasts: [], nextId: 1 };
  },
  mounted() {
    registerToast((opts) => this.addToast(opts));
  },
  methods: {
    addToast(opts) {
      const id = this.nextId++;
      this.toasts.push({ id, ...opts });
      const life = opts.life ?? 6000;
      if (life > 0) {
        setTimeout(() => this.dismiss(id), life);
      }
    },
    dismiss(id) {
      const i = this.toasts.findIndex((t) => t.id === id);
      if (i !== -1) this.toasts.splice(i, 1);
    },
  },
};
</script>

<style scoped>
.app-toast-wrap {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999999;
  pointer-events: none;
}
.app-toast-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.app-toast-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 280px;
  max-width: 400px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  font-family: var(--q-font-ui, 'Inter', sans-serif);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  pointer-events: all;
}
.app-toast--success {
  background: var(--q-green-soft, #0c2a1a);
  border-color: var(--q-green, #2ee27f);
  color: var(--q-green, #2ee27f);
}
.app-toast--error {
  background: var(--q-red-soft, #2c1216);
  border-color: var(--q-red, #ff5964);
  color: var(--q-red, #ff5964);
}
.app-toast--warn {
  background: var(--q-amber-soft, #241a09);
  border-color: var(--q-amber, #f5a623);
  color: var(--q-amber, #f5a623);
}
.app-toast--info {
  background: var(--q-hover, #111926);
  border-color: var(--q-border-md, #243040);
  color: var(--q-text, #e7edf5);
}

.app-toast-icon { font-size: 1.1rem; flex-shrink: 0; }
.app-toast-body { display: flex; flex-direction: column; flex: 1; gap: 2px; }
.app-toast-summary {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.8;
}
.app-toast-detail { font-size: 0.875rem; font-weight: 500; line-height: 1.3; }
.app-toast-close {
  background: none; border: none; color: inherit;
  font-size: 1.2rem; line-height: 1; padding: 0 0 0 6px;
  cursor: pointer; opacity: 0.6; flex-shrink: 0;
}
.app-toast-close:hover { opacity: 1; }

/* Animación entrada/salida */
.app-toast-enter-active,
.app-toast-leave-active { transition: all 0.25s ease; }
.app-toast-enter-from   { opacity: 0; transform: translateX(40px); }
.app-toast-leave-to     { opacity: 0; transform: translateX(40px); }
</style>
